import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { CSAT } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/CSAT" component={CSAT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/CSAT/routes.js